import React from "react";
import { useSelector } from "react-redux";
import { authSelector, orgSelector } from "../../redux/selectors";
import { useSearch, useUrl } from "@ofqual/portal-core/core/hooks";
import { ApplicationsList } from "./ApplicationsList";
import { Pager } from "@ofqual/portal-components/components/Pager";
import { FilterControls } from "./FilterControls";
import { makeStyles } from "@material-ui/core";
import { useParams } from "react-router-dom";
import { NewExpansionButtonAndDialog } from "./NewExpansionButtonAndDialog";
import { UserRole } from "../../domain/userRole";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { Skeleton } from "@material-ui/lab";
import { OrganisationAppBar } from "../OrganisationAppBar";
import { useExpansionApplicationState } from "../../hooks/useExpansionApplicationState";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginTop: theme.contentOffsets.AFTER_SECONDARY_APPBAR,
    },
  };
});

export const ExpansionApplicationsList: React.FC = () => {
  const classes = useStyles();

  const orgState = useSelector(orgSelector);
  const { org } = orgState;

  const { searchParams, navigateToNextPage } = useSearch(useUrl());

  const { itemId } = useParams<{ itemId: string }>();
  const { isInRole } = useAuth(authSelector);
  const isAoUser = isInRole(
    UserRole.AOAdmin,
    UserRole.AoResponsibleOfficer,
    UserRole.AORegulationTeam,
    UserRole.ITAdmin
  );
  if (!isAoUser) {
    searchParams.excludeDraft = true;
  }

  const expansionApplications = useExpansionApplicationState(
    itemId,
    searchParams
  );
  return (
    <div className={classes.root}>
      <OrganisationAppBar
        breadcrumbs={[
          { label: `${org?.name}`, to: itemId },
          { label: "Scope of Recognition Applications" },
        ]}
      >
        <FilterControls canViewDraft={isAoUser} />
        {isAoUser ? <NewExpansionButtonAndDialog /> : null}
      </OrganisationAppBar>

      {expansionApplications && expansionApplications.hasData ? (
        <>
          <Pager
            state={expansionApplications}
            navigateToNextPage={navigateToNextPage}
          />
          <div>
            <ApplicationsList state={expansionApplications} />
          </div>
        </>
      ) : (
        <>
          <Skeleton variant="text" height={60} />
          <Skeleton variant="text" height={60} />
          <Skeleton variant="text" height={60} />
          <br />
          <Skeleton variant="rect" height={118} />
        </>
      )}
    </div>
  );
};
